import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.css']
})
export class PublicHeaderComponent implements OnInit {
  email: any;
  name: any;
  lastname: any;
  claims: any;
  names: string;
  nameTool: any;
  side: boolean;
  ActiveModule: any
  selectLang: string;
  constructor(public translate: TranslateService, public paginator: MatPaginatorIntl) {
    translate.addLangs(['en', 'es']);
    if(sessionStorage.lang === undefined || sessionStorage.lang == null){
      translate.setDefaultLang('es');
      this.selectLang = 'es';
      sessionStorage.setItem('lang', 'es');
    } else {
      this.selectLang = String(sessionStorage.lang);
      translate.use(String(sessionStorage.lang))
    }

  }


  updateLang(lang) {
    sessionStorage.setItem('lang', lang);
    this.selectLang = lang;
  }

  ngOnInit() {
  }

}
